exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md_right-wrong-icon {\n  display: inline-block;\n  height: 1em;\n}\n#downloadPage input {\n  border: 1px #dddddd solid;\n}\n.ticket-download-actions {\n  position: absolute;\n  top: 20px;\n  right: 30px;\n  z-index: 9999;\n}\n.ticket-download-actions > a,\n.ticket-download-actions > uib-dropdown {\n  z-index: 10000;\n  margin: 0 5px;\n  padding: 10px 0;\n}\n.accordion-unit {\n  margin-bottom: 20px;\n}\n.personalise-btn[disabled] {\n  background-color: #d7d7d7 !important;\n  cursor: not-allowed;\n}\n", ""]);

// exports
